var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmDialog',{ref:"dialog",attrs:{"msg":"ここまでの情報を保存して終了しますか？","titleSubmit":"保存して終了する","titleCancel":"保存して継続する"},on:{"onclose":_vm.onClose,"onsubmit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }